import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ApiService } from '../api.service';
import { Room } from '../../models';
import { API_CALL_URL } from './apiCallConectateUrl.constants';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SurveyResponse } from '../../models/survey.model';
import { VIDEOCONFERENCE_CONSTANTS } from '../../constants/videoconference.constants';
import { UtilsService } from '../../services/utils/utils.service';
import { EnvironmentService } from '../../services/enviroment/environment.service';
import { SessionStorageService } from '../../services/session-storage/session-storage.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiConectateService extends ApiService {
  private apiUrl: string;
  private mockRoom: Room = {
    activeSurvey: true,
    roomTitle: 'title',
    attendantName: 'Jaime',
    attendantNames: ['Peter'],
    providedId: '1_MX40NjYwMzE0Mn5-MTU4NzA0NTk4MzY2Mn44cnpqaTd5M0I4emNIQ1JEbC83c21Xa2p-UH4',
    token: 'T1==cGFydG5lcl9pZD00NjYwMzE0MiZzaWc9YmM3ZWU2ZmI2ZThjZjIxYWI3ZGVmZjE1NmU0YTI1NTM5ZGFkOWUzZjpzZXNzaW9uX2lkPTFfTVg0ME5qWXdNekUwTW41LU1UVTROekEwTlRrNE16WTJNbjQ0Y25wcWFUZDVNMEk0ZW1OSVExSkViQzgzYzIxWGEycC1VSDQmY3JlYXRlX3RpbWU9MTU4NzA0NjEyNCZub25jZT0yMDIxMjA3NTg1JnJvbGU9bW9kZXJhdG9yJmV4cGlyZV90aW1lPTE1ODk2MzgxMjQmY29ubmVjdGlvbl9kYXRhPXRoaXMraW5mbyt3aWxsK2JlK2Fzc29jaWF0ZWQrd2l0aCt0aGUrY2xpZW50K2Nvbm5lY3Rpb24='
  };
  private connectionId?: string;
  get _connectionId(): string {
    const id = this.sessionStorageSrv.get("connectionId");
    return id || this.connectionId;
  }
  set _connectionId(connectionId: string) {
    this.sessionStorageSrv.set("connectionId", connectionId);
    this.connectionId = connectionId;
  }
  private hasAuthBasic: boolean;

  constructor(
    utils: UtilsService,
    private readonly apiService: ApiService,
    private readonly environmentService: EnvironmentService,
    private readonly http: HttpClient,
    private readonly route: ActivatedRoute,
    private readonly sessionStorageSrv: SessionStorageService
  ) {
    super(utils);
    this.apiUrl = environmentService.data.apiUrl;
    this.hasAuthBasic = environmentService.data.authorizationBasic as boolean;

  }

  public accessRoom(attendantId: string, pin?: string, mock?: boolean): any {
    if (mock) {
      return of(this.mockRoom);
    }

    let apiInstance;
    apiInstance = this.apiService.getApiInstance(API_CALL_URL.ROOM_ACCESS_PIN);
    apiInstance.params['attendantId'].value = attendantId;

    if (this.environmentService.data?.features.pin_required && pin) {
      apiInstance.params['key'].value = 'pin=';
      apiInstance.params['password'].value = pin;
    }

    const url = this.apiService.getApiUrl(this.environmentService.data.apiUrl, apiInstance);
    const authorizationHeader = this.getAuthorizationHeader(apiInstance.security.authorizationBasic);

    return this.hasAuthBasic ? this.http.put<Room>(url, {}, authorizationHeader) : this.http.put<Room>(url, {});
  }

  public getAuthentication(attendantId: string, password?: string) {
    const apiInstance = this.apiService.getApiInstance(API_CALL_URL.ROOM_VALIDATE);
    apiInstance.params['attendantId'].value = attendantId;

    if (password) {
      apiInstance.params['password'].value = password;
    }

    const url = this.apiService.getApiUrl(this.environmentService.data.apiUrl, apiInstance);
    const authorizationHeader = this.getAuthorizationHeader(apiInstance.security.authorizationBasic);

    return this.hasAuthBasic ? this.http.get(url, authorizationHeader) : this.http.get(url);
  }

  // getAttendants(attendantId: string) {
  //   const apiInstance = this.apiService.getApiInstance(API_CALL_URL.GET_ATTENDANTS);
  //   apiInstance.params.attendantId.value = attendantId;

  //   const url = this.apiService.getApiUrl(this.environmentService.data.apiUrl, apiInstance);
  //   const authorizationHeader = this.getAuthorizationHeader(apiInstance.security.authorizationBasic);

  //   return this.hasAuthBasic ? this.http.get(url, authorizationHeader) : this.http.get(url);
  // }

  getAttendants(attendantId: string) {
    const apiInstance = this.apiService.getApiInstance(API_CALL_URL.GET_ATTENDANTS);
    apiInstance.params['id'].value = attendantId;

    const url = this.apiService.getApiUrl(this.environmentService.data.apiUrl, apiInstance);
    const authorizationHeader = this.getAuthorizationHeader(apiInstance.security.authorizationBasic);

    return this.hasAuthBasic ? this.http.get(url, authorizationHeader) : this.http.get(url);
  }

  getConnectionTestToken(attendantId?: string) {
    let apiInstance;
    if(environment.isPatient) {
      apiInstance = this.getApiInstance(API_CALL_URL.CONNECTION_TEST_TOKEN_PATIENT)
      apiInstance.params['attendantId'].value = attendantId;
    }else{
      apiInstance = this.getApiInstance(API_CALL_URL.CONNECTION_TEST_TOKEN)
    }
    const url = this.getApiUrl(this.apiUrl, apiInstance);
    const authorizationHeader = this.getAuthorizationHeader(apiInstance.security.authorizationBasic);

    return this.hasAuthBasic ? this.http.get(url, authorizationHeader) : this.http.get(url);
  }

  createInvitation(invitationData: any): Observable<any> {
    const apiInstance = this.getApiInstance(API_CALL_URL.SEND_INVITATION);
    const url = this.getApiUrl(this.environmentService.data.apiUrl, apiInstance);
    const authorizationHeader = this.getAuthorizationHeader(apiInstance.security.authorizationBasic);

    return this.hasAuthBasic ? this.http.post(url, invitationData, authorizationHeader) : this.http.post(url, invitationData);
  }

  sendInvitation(invitationData: FormGroup) {
    const apiInstance = this.getApiInstance(API_CALL_URL.SEND_INVITATION);
    const url = this.getApiUrl(this.environmentService.data.apiUrl, apiInstance);
    const authorizationHeader = this.getAuthorizationHeader(apiInstance.security.authorizationBasic);

    return this.hasAuthBasic ? this.http.post(url, this.createObjectToSend(invitationData), authorizationHeader) : this.http.post(url, this.createObjectToSend(invitationData));
  }

  createObjectToSend(invitationData: FormGroup) {
    const token: string = this.route.snapshot.queryParams['access'].split('/')[0];
    const invitationDataFormated = {
      id: token,
      name: invitationData.controls['name'].value,
      email: invitationData.controls['email'].value,
    };

    return invitationDataFormated;
  }

  getSurveyQuestions(active: boolean = true, role?: string) {
    const apiInstance = this.getApiInstance(API_CALL_URL.GET_ACTIVE_SURVEY);
    apiInstance.params['active'].value = active;

    if (role) {
      apiInstance.params['role'].value = role;
    }

    const url = this.getApiUrl(this.environmentService.data.apiUrl, apiInstance);
    const authorizationHeader = this.getAuthorizationHeader(apiInstance.security.authorizationBasic);

    return this.hasAuthBasic ? this.http.get(url, authorizationHeader) : this.http.get(url);
  }

  sendSurvey(surveyId: number = 0, survey: SurveyResponse) {
    let apiInstance;
    if(environment.isPatient){
      apiInstance = this.getApiInstance(API_CALL_URL.SEND_SURVEY_PATIENT);
      survey.connectionId = this._connectionId;
    }else{
      apiInstance= this.getApiInstance(API_CALL_URL.SEND_SURVEY);

    }
    apiInstance.params['surveyId'].value = surveyId;
    survey.participantId = this.route.snapshot.queryParams['access'];


    const url = this.getApiUrl(this.environmentService.data.apiUrl, apiInstance);
    const authorizationHeader = this.getAuthorizationHeader(apiInstance.security.authorizationBasic);

    return this.hasAuthBasic ? this.http.post(url, survey, authorizationHeader) : this.http.post(url, survey);
  }

  getUserState(attendantId: string): Observable<any> {
    const apiInstance = this.apiService.getApiInstance(API_CALL_URL.GET_USER_STATE);
    apiInstance.params['attendantId'].value = attendantId;

    const url = this.apiService.getApiUrl(this.environmentService.data.apiUrl, apiInstance);
    const authorizationHeader = this.getAuthorizationHeader(apiInstance.security.authorizationBasic);

    return this.hasAuthBasic ? this.http.get(url, authorizationHeader) : this.http.get(url);
  }

  sendConection(userId: string, connectId: string) {
    console.log('UserId: ' + userId + ', ConectId: ' + connectId);
    const apiInstance = this.getApiInstance(API_CALL_URL.SEND_CONNECTION);
    const url = this.getApiUrl(this.environmentService.data.apiUrl, apiInstance);
    const body = {
      attendantId: userId,
      connectionId: connectId
    };
    const authorizationHeader = this.getAuthorizationHeader(apiInstance.security.authorizationBasic);

    return this.hasAuthBasic ? this.http.post(url, body, authorizationHeader) : this.http.post(url, body);
  }

  sendUserState(state: boolean) {
    const attendantId = this.route.snapshot.queryParams[VIDEOCONFERENCE_CONSTANTS.URL_PARAM_ATTENDANT];
    this.setUserState(attendantId, state).subscribe();
  }

   sedPatientConnectedNotification(): Observable<any> {
    const apiInstance = this.apiService.getApiInstance(
      API_CALL_URL.PATTIENT_CONNECTED_NOTIFICATION
    );
    const attendantId =
      this.route.snapshot.queryParams[
        VIDEOCONFERENCE_CONSTANTS.URL_PARAM_ATTENDANT
      ];
    apiInstance.params['attendantId'].value = attendantId;
    const body = {};
    const authorizationHeader = this.getAuthorizationHeader(
      apiInstance.security.authorizationBasic
    );
    const url = this.getApiUrl(
      this.environmentService.data.apiUrl,
      apiInstance
    );

    return this.hasAuthBasic
      ? this.http.post(url, body, authorizationHeader)
      : this.http.post(url, body);
  }


  private setUserState(attendantId: string, active: boolean): Observable<any> {
    const apiInstance = this.apiService.getApiInstance(API_CALL_URL.SET_USER_STATE);
    apiInstance.params['attendantId'].value = attendantId;
    apiInstance.params['active'].value = active?.toString();

    const url = this.getApiUrl(this.environmentService.data.apiUrl, apiInstance);
    const authorizationHeader = this.getAuthorizationHeader(apiInstance.security.authorizationBasic);

    return this.hasAuthBasic ? this.http.patch(url, apiInstance, authorizationHeader) : this.http.patch(url, apiInstance);
  }

  private getAuthorizationHeader(authorizationBasicCode: string): any {
    return { headers: { 'authorization': authorizationBasicCode }};
  }

}
